import api from '@lib/utility/api';

// Имя файла отдаёт бэкенд в Content-Disposition (kyt_TRX_TU4v…_2026-10-27.pdf).
// Если заголовок не проброшен через CORS — собираем такое же.
const fallbackFileName = (network, address) =>
  `kyt_${network}_${address}_${new Date().toISOString().split('T')[0]}.pdf`;

const parseFileName = (contentDisposition) => {
  const match = contentDisposition?.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
  if (!match) {
    return null;
  }
  try {
    return decodeURIComponent(match[1].trim());
  } catch {
    return match[1].trim();
  }
};

// При responseType: 'blob' тело ошибки тоже приходит blob'ом — достаём из него JSON с detail
const readErrorData = async (data) => {
  if (!(data instanceof Blob)) {
    return data;
  }
  try {
    return JSON.parse(await data.text());
  } catch {
    return null;
  }
};

// PDF-отчёт провайдера по проверке. Запрос идёт к провайдеру (до 5–10 с), нужен X-Token — поэтому не <a href>.
// У ошибки те же status и data, что у ошибок RTK Query, — показываем её через getErrorMessage.
export const downloadKytReport = async ({ network, address, checkSk }) => {
  let response;
  try {
    response = await api.get('/admin/crypto-addresses/kyt/report', {
      params: { network, address, check_sk: checkSk },
      responseType: 'blob',
      headers: { Accept: 'application/pdf' },
    });
  } catch (error) {
    throw Object.assign(new Error('KYT report request failed'), {
      status: error.response?.status,
      data: await readErrorData(error.response?.data),
    });
  }

  const fileName =
    parseFileName(response.headers['content-disposition']) || fallbackFileName(network, address);
  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);

  return fileName;
};
